import { FormControl, FormLabel } from "@chakra-ui/react";
import { SYLA_EARLIEST_EVENT_DATE } from "@syla/shared/types/helpers/constants";
import React from "react";
import {
  Controller,
  FieldPath,
  FieldValues,
  UseFormReturn,
} from "react-hook-form";
import { AccountTimeZone } from "../../../../constants/AccountTimeZone";
import { DatePicker } from "../../../atoms/datePicker/DatePicker";
import { startOfMinuteInTimeZone } from "../../../atoms/datePicker/tzDateUtils";
import { InfoToolTip } from "../../../atoms/InfoToolTip";

export function SyncFromDateField<T extends FieldValues>({
  form,
  name,
}: {
  form: UseFormReturn<T>;
  name: FieldPath<T>;
}) {
  return (
    <FormControl>
      <FormLabel display="flex" alignItems="center" gap={1}>
        Import from date
        <InfoToolTip
          label="Specify the earliest date you want to start importing transactions from. Otherwise, Syla will import all available transactions."
          wrap
        />
      </FormLabel>
      <Controller
        control={form.control}
        name={name}
        render={({ field }) => (
          <DatePicker
            value={field.value || undefined}
            earliestDate={SYLA_EARLIEST_EVENT_DATE}
            latestDate={startOfMinuteInTimeZone(new Date(), AccountTimeZone)}
            onChange={(selection) => field.onChange(selection ?? undefined)}
            showTime
            timeZone={AccountTimeZone}
            inputProps={{
              backgroundColor: "white",
            }}
          />
        )}
      />
    </FormControl>
  );
}
